import React, { useContext, useMemo, useState } from 'react';
import Config from '@skin_config';
import { PreferencesContext } from '@common/contexts/preferences';
import { PopupContext } from '@app/dev/contexts/popup';
import { useTranslation } from '@common/hooks/translation';

import './style.scss';

const TermsAndConditions = () => {
  const [selected, setSelected] = useState(0);
  const [selectedSub, setSelectedSub] = useState(0);
  const [{ lang }] = useContext(PreferencesContext);
  const [{ closePopup }] = useContext(PopupContext);
  const t = useTranslation();

  const subTabs = useMemo(() => {
    const selectedSection = Config.termsAndConditions?.[selected];

    if (selectedSection?.hasSubTabs) return selectedSection.subTabs;
    return null;
  }, [selected]);

  const getDefaultLang = (obj) => obj?.[lang] || obj?.[Config.main.termsAndConditionsDefaultLanguage];

  return (
    <div className="popup-content">
      <div className="term-and-conditions-wrapper">
        <div className="term-and-conditions-sidebar">
          {Config.termsAndConditions.map((item, index) => (
            <span
              onClick={() => setSelected(index)}
              className={`h-r-tab ${index === selected ? 'active' : ''}`}
              key={item}
            >
              <span>{getDefaultLang(item.title)}</span>
            </span>
          ))}
        </div>

        <div className="term-main-content">

          <div className="rules-r-b">
            <div className="help-tabs-bar">
              {subTabs?.map((item, index) => (
                <span
                  className={`h-r-tab ${index === selectedSub ? 'activ' : ''}`}
                  key={getDefaultLang(item.title)}
                  onClick={() => setSelectedSub(index)}
                >
                  {getDefaultLang(item.title)}
                </span>
              ))}
            </div>
            <div className="point-selected-i">
              <p
                dangerouslySetInnerHTML={{
                  __html: getDefaultLang(
                    subTabs
                      ? subTabs[selectedSub].textSubTranslationKey
                      : Config.termsAndConditions[selected].textTranslationKey,
                  ),
                }}
              />
            </div>
          </div>
          <button type="button" onClick={closePopup} className="popup-cancel-button">
            {t('Close')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
